import React, { FC } from 'react';

import { useIsViewport, Viewports } from '~/hooks/useIsViewport';
import { useIsHomePageRedesignEnabled } from '~/modules/home/useIsHomePageRedesignEnabled';

import DesktopSidebarHeader from './components/DesktopSidebarHeader';
import { HomePageV2HeaderDesktop } from './components/HomePageV2Header/HomePageV2HeaderDesktop';
import { HomePageV2HeaderMobile } from './components/HomePageV2Header/HomePageV2HeaderMobile';
import HomePageV2Sidebar from './components/HomePageV2Sidebar';
import MobileSidebarHeader from './components/MobileSidebarHeader';
import { useMainLayoutSidebarGroups } from './hooks/useMainLayoutSidebarGroups';

type Props = {
  children?: React.ReactNode;
};

const MainLayout: FC<Props> = ({ children }) => {
  const sidebarGroups = useMainLayoutSidebarGroups();
  const isDesktop = useIsViewport(Viewports.EXTRA_SMALL_DESKTOP);
  const isHomePageRedesignEnabled = useIsHomePageRedesignEnabled();
  const renderHomePageV2Sidebar = isHomePageRedesignEnabled
    ? (onClickClose: () => void): JSX.Element => (
        <HomePageV2Sidebar isMobile onClose={onClickClose} />
      )
    : undefined;
  const renderHomePageV2Header = isHomePageRedesignEnabled
    ? (onClickOpen: () => void): JSX.Element => (
        <HomePageV2HeaderMobile onClickOpen={onClickOpen} />
      )
    : undefined;

  if (isDesktop) {
    return (
      <DesktopSidebarHeader
        sidebarGroups={sidebarGroups}
        header={
          isHomePageRedesignEnabled ? <HomePageV2HeaderDesktop /> : undefined
        }
        sidebar={isHomePageRedesignEnabled ? <HomePageV2Sidebar /> : undefined}
      >
        {children}
      </DesktopSidebarHeader>
    );
  }

  return (
    <MobileSidebarHeader
      sidebarGroups={sidebarGroups}
      renderHeader={renderHomePageV2Header}
      renderSidebar={renderHomePageV2Sidebar}
    >
      {children}
    </MobileSidebarHeader>
  );
};

export default MainLayout;
